export default {}.hasOwnProperty
